import { render, staticRenderFns } from "./ProjectInvite.vue?vue&type=template&id=f7b86ef2&scoped=true&"
import script from "./ProjectInvite.vue?vue&type=script&lang=ts&"
export * from "./ProjectInvite.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectInvite.vue?vue&type=style&index=0&id=f7b86ef2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7b86ef2",
  null
  
)

export default component.exports